export const CommissionSplitWarningMsg = {
	WaterfallErrorMessage: "Sum of all commission split should equal 100%",
	OverrideErrorMessage: "Split % must not be more than 100%",
	IncorrectOverrideTotalAmount:
		"Split %'s cannot total more or less than total revenue share % (excluding BD)",
	DuplicateAgentErrorMessage:
		"Agent is already selected as primary or secondary split.",
};
